import {
  Skeleton,
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui'
import {
  useCreditBank,
  useLoadingCreditBank,
} from '@/modules/account/creditBankStore'
import type { Wallet } from '@/modules/account/types'
import { GroupedEntryRow } from './GroupedEntryRow'
import { groupEntries } from './groupEntries'

const EMPTY_MESSAGE: Record<Wallet, string> = {
  pages: 'No credit activity yet.',
  screenings: 'No screening activity yet.',
}

export const CreditHistory = ({ wallet }: { wallet: Wallet }) => {
  const creditBank = useCreditBank(wallet)
  const isLoading = useLoadingCreditBank(wallet)

  if (isLoading && !creditBank) {
    return <Skeleton className="h-40 w-full rounded-xl" />
  }

  const groups = groupEntries(creditBank?.entries ?? [])

  if (groups.length === 0) {
    return (
      <p className="text-muted-foreground text-lg">{EMPTY_MESSAGE[wallet]}</p>
    )
  }

  return (
    <div className="rounded-lg border bg-white overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-8" />
            <TableHead>Date</TableHead>
            <TableHead>Description</TableHead>
            <TableHead className="text-right">Amount</TableHead>
            <TableHead>Expires</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {groups.map((group) => (
            <GroupedEntryRow key={group.key} group={group} />
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
